import { memo } from 'react'
import { DeepNullable } from '../../utilities'

export type StrapiSvgData = null | DeepNullable<{
  localFile: {
    publicURL: string
  }
}>

type Props = {
  strapiSvg?: StrapiSvgData
  alt?: string
  isRequired?: boolean
  className?: string
}

export const StrapiSvg = memo<Props>(
  ({ strapiSvg, alt = '', className, isRequired = false }) => {
    if (strapiSvg?.localFile?.publicURL) {
      return (
        <img
          src={strapiSvg.localFile.publicURL}
          alt={alt}
          className={className}
        />
      )
    }
    if (isRequired) {
      console.error(strapiSvg, JSON.stringify(strapiSvg, null, 2))
      throw new Error('Required svg is missing: ')
    }
    return null
  },
)
StrapiSvg.displayName = 'StrapiSvg'
